import { getCurrentLanguage } from '~/localization';
import { fetchFromOldApi } from '~/services/Http';

export type UpCustomData = {
  code: string;
  description: string;
  name: string;
  seq: number;
};

export type UpCustomDataAttribute = {
  fCustomDataAttributeCountry: string[];
  fCustomDataAttributeDataType: string;
  fCustomDataAttributeLabel: string;
  fCustomDataAttributeName: string;
  fCustomDataCreatedTime: string;
  fCustomDataCreatedUserId: number;
  fCustomDataUpdatedTime: string;
  fCustomDataUpdatedUserId: number;
  fCustomDataAttributeDataSubtype?: string;
};

export type IndexedUpCustomDataAttribute = {
  [key: string]: UpCustomDataAttribute;
};

//TODO: THINK ABOUT COUNTRY FILTER
export const getCustomDataUnitPosition = async (): Promise<UpCustomData[]> => {
  const currentLanguage = getCurrentLanguage();
  return await fetchFromOldApi(
    `/json/enum/CUSTOM_ENTITY_UNIT_POSITION/${currentLanguage}?includeInactive=false`,
  ).then((r) => r.json());
};

export const customDataAttributes =
  async (): Promise<IndexedUpCustomDataAttribute> => {
    return await fetchFromOldApi(
      `/json/customdata/entity/UNIT_POSITION/attribute`,
    ).then((r) =>
      r
        .json()
        .then((r: UpCustomDataAttribute[]) =>
          r.reduce(
            (acc, cur) => ({ ...acc, [cur.fCustomDataAttributeName]: cur }),
            {},
          ),
        ),
    );
  };
